import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { OficinaService } from '../services/oficina.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-oficinas-edit',
	templateUrl: './oficinas-edit.component.html',
	styleUrls: ['./oficinas-edit.component.css'],
	animations: [loadingFade]
})
export class OficinasEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public oficina_id = null;

	public formOficina: FormGroup;

	public uf_array = [];
	public municipio_array = [];
	public bairro_array = [];

	constructor(private authSvc: AuthService,
		private route: ActivatedRoute,
		private fb: FormBuilder,
		private router: Router,
		private oficinaSvc: OficinaService,
	) { }

	ngOnInit() {
		this.criaForm();

		this.route.params.subscribe(params => {
			if (params.id) {
				this.oficina_id = params.id;
				// pega dados a partir do id
				this.oficinaSvc.getOficina(params.id).then((data: any) => {
					this.preencheForm({
						oficina_id: data.oficina_id,
						usuario_id: this.authSvc.getUsuarioId(),
						unidade_id: '',
						cliente_id: '',
						oficina_nome: data.oficina_nome,
						oficina_contato: data.oficina_contato,
						oficina_cnpj: data.oficina_cnpj,
						oficina_endereco: data.oficina_endereco,
						oficina_endereco_numero: data.oficina_endereco_numero,
						oficina_cep: data.oficina_cep,
						oficina_municipio: data.oficina_municipio,
						oficina_bairro: data.oficina_bairro,
						oficina_uf: data.oficina_uf
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formOficina = this.fb.group({
			oficina_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
			unidade_id: '',
			cliente_id: '',
			oficina_nome: [null, Validators.required],
			oficina_contato: [null, Validators.required],
			oficina_cnpj: null,
			oficina_endereco: null,
			oficina_endereco_numero: null,
			oficina_cep: null,
			oficina_municipio: null,
			oficina_bairro: null,
			oficina_uf: null,
		});
	}

	preencheForm(dados) {
		this.formOficina.setValue(dados);
	}


	enviaOficina() {
		if (this.formOficina.valid) {
			this.submitting = true;

			let toSend = this.formOficina.value;

			if (this.oficina_id === null) { // criar
				console.log("[toSend]", toSend);
				this.oficinaSvc.criaOficina(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Oficina cadastrada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/oficinas']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.oficinaSvc.editaOficina(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Oficina alterada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/oficinas']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else {
			for (let field in this.formOficina.controls) {
				let campo = this.formOficina.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formOficina.get(nome);
		return input.touched && input.invalid;
	}
}
